import { render } from "./UserAuth.vue?vue&type=template&id=32c32a5d&scoped=true&bindings={\"email\":\"data\",\"password\":\"data\",\"formisValid\":\"data\",\"mode\":\"data\",\"isLoading\":\"data\",\"error\":\"data\",\"submitButtonCaption\":\"options\",\"switchModeButtonCaption\":\"options\",\"submitForm\":\"options\",\"switchAuthMode\":\"options\",\"handleError\":\"options\"}"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=32c32a5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32c32a5d"

export default script